import Tooltip from '@carvana/ds-tooltip';
import { Info } from 'lucide-react';
import { useFinancingContext } from '~/context/flp/FinancingContext';
import { QualifiedVehicleDetails } from '~/contracts/flp';
import {
  Header,
  Label,
  LabelTypography,
  RefreshBlock,
  TermItem,
  Terms,
  Text,
  YourTermsContainer
} from './YourTerms.styles';

const YourTerms = () => {
  const { isLoading, aggregates } = useFinancingContext();
  const { minDownVehicle, minPaymentVehicle } = aggregates || {};
  const perMonthValue = `${minPaymentVehicle?.monthlyPayment.toLocaleString(
    'en-US',
    {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0
    }
  )}/mo`;
  const minCashDownValue = minDownVehicle?.downPayment.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  });

  const getTooltipCopy = (vehicle: QualifiedVehicleDetails) => {
    const { stickerPrice, downPayment, apr, term } = vehicle || {};
    const displayApr = Number(apr).toLocaleString('en-US', {
      style: 'percent',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    return `Based on a $${stickerPrice?.toLocaleString(
      'en-US'
    )} vehicle sale price with $${downPayment?.toLocaleString(
      'en-US'
    )} cash down, an APR
                of ${displayApr}, and a term of ${term} months. Actual terms may vary based on
                vehicle selection.`;
  };

  return (
    <YourTermsContainer id="your-terms">
      <Header>Your terms</Header>
      <Terms>
        <TermItem>
          <Label>
            <LabelTypography>As low as</LabelTypography>
            <Tooltip
              content={getTooltipCopy(aggregates?.minPaymentVehicle!)}
              direction="bottomLeft"
              header="Monthly payment as low as"
              showCloseBtn={false}
              width="250px"
            >
              <Info color="white" size={16} />
            </Tooltip>
          </Label>
          {isLoading ? <RefreshBlock /> : <Text>{perMonthValue}</Text>}
        </TermItem>

        <TermItem>
          <Label>
            <LabelTypography>Minimum cash down</LabelTypography>
            <Tooltip
              content={getTooltipCopy(aggregates?.minDownVehicle!)}
              header="Minimum cash down"
              showCloseBtn={false}
            >
              <Info color="white" size={16} />
            </Tooltip>
          </Label>
          {isLoading ? <RefreshBlock /> : <Text>{minCashDownValue}</Text>}
        </TermItem>
      </Terms>
    </YourTermsContainer>
  );
};

export default YourTerms;
